import { gql, useMutation } from '@apollo/client'
import { TextMaterial, UpdateTextMaterialInput } from '@@partner:types:app'
import { SHORTCUT_TEXT_MATERIAL_FIELDS } from '@@partner:graphql/query/textMaterial/textMaterialShortcut';

export interface UpdateTextMaterial {
  updateTextMaterial: TextMaterial
}

export interface UpdateTextMaterialVariables {
  textMaterialInfo: UpdateTextMaterialInput;
  upsert: boolean;
}

export const GQL_MUTATION_UPDATE_TEXT_MATERIAL = gql`
  mutation($textMaterialInfo: TextMaterialInput!, $upsert: Boolean!) {
    updateTextMaterial(textMaterialInfo: $textMaterialInfo, upsert: $upsert) {
      ${SHORTCUT_TEXT_MATERIAL_FIELDS}
    }
  }
`

export const useMutateUpdateTextMaterial = () =>
  useMutation<UpdateTextMaterial, UpdateTextMaterialVariables>(
    GQL_MUTATION_UPDATE_TEXT_MATERIAL
  )
